// extracted by mini-css-extract-plugin
export var actions = "_6z-8";
export var arrow = "_6z-5";
export var card = "_6z-0";
export var cardWrapper = "_6z-9";
export var fieldName = "_6z-3";
export var newValue = "_6z-6";
export var oldValue = "_6z-4";
export var orangeGlowFade = "_6z-c";
export var productSection = "_6z-1";
export var scrollToBottom = "_6z-b";
export var scrollToBottomAnchor = "_6z-a";
export var scrollToBottomIcon = "_6z-d";
export var showAllButton = "_6z-7";
export var table = "_6z-2";